import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import authService from '../../services/authService';
import userService from '../../services/userService';
import { UserModel, UserLoginModel } from '../../types';
import localStorage from '../../utils/localStorage';
import { getInitials } from '../../utils/helper';
import { doLogout } from '../../utils/auth';
import { RootState } from '../index';
import myEventSlice from '../myEvents/myEventSlice';
import myFavoriteSlice from '../myFavorites/myFavoritesSlice';
import userSlice from './userSlice';

export const userActions = userSlice.actions;

export const userLogin = (data: UserLoginModel): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    let res = await authService.doLogin({
      mobileNo: data.mobileNo,
      password: data.password,
    });
    console.log(res);
    if (res.data.resultCode === 0) {
      let user: UserModel = res.data.data.login;
      localStorage.setItem('appToken', res.data.data.token.appToken);
      localStorage.setItem('exp', res.data.data.token.exp);
      localStorage.setItem('mobileNo', JSON.stringify(user.mobileNo));
      localStorage.setItem('refreshToken', res.data.data.token.refreshToken);

      user.intialName = getInitials(user.name || '');

      dispatch(
        userActions.setProfile({
          data: {
            user,
            loginStatus: true,
          },
        }),
      );
    } else {
      dispatch(
        userActions.setProfile({
          data: {
            user: null,
            loginStatus: false,
            errorMsg: res.data.resultMessage,
          },
        }),
      );
    }
  };
};

export const fetchUserProfile = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    let res = await userService.getUser();
    if (res.data.resultCode === 0) {
      let user: UserModel = res.data.data.user;

      user.intialName = getInitials(user.name || '');

      dispatch(
        userActions.setProfile({
          data: {
            user,
          },
        }),
      );
    } else {
      dispatch(
        userActions.setProfile({
          data: {
            user: null,
          },
        }),
      );
    }
  };
};

export const validateSession = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    let res = await authService.validate();
    if (res.data.resultCode === 0) {
      let user: UserModel = res.data.data;

      user.intialName = getInitials(user.name || '');

      dispatch(
        userActions.setProfile({
          data: {
            user,
            validateSession: true,
          },
        }),
      );
    } else {
      dispatch(
        userActions.setProfile({
          data: {
            user: null,
            validateSession: false,
            errorMsg: 'Error on validate session or session expired.',
          },
        }),
      );
    }
  };
};

export const logoutUser = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    await doLogout();

    dispatch(userActions.setLogout());
    dispatch(myEventSlice.actions.clearMyEvents());
    dispatch(myFavoriteSlice.actions.clearMyFav());
  };
};

export const setUser = (user: UserModel): ThunkAction<void, RootState, unknown, AnyAction> => {
  console.log(user);
  return async dispatch => {
    dispatch(userActions.setProfile({ data: { user, validateSession: true } }));
  };
};

export const clearUser = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(userActions.clear());
  };
};
